/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Form } from 'antd';
import { Grid, Switch, TextField, FormControlLabel } from '@material-ui/core';

class siteForm extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  constructor(props) {
    super(props);

    const useTranslator = localStorage.getItem('useTranslator');

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      useTranslator: useTranslator ? !!(useTranslator === 'true') : false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let variables = {
          id: this.props.id,
          name: values.name,
          email: values.email,
          password: values.password,
        };
        if (values.password === this.props.password) {
          variables = {
            id: this.props.id,
            name: values.name,
            email: values.email,
          };
        }
        this.props.query_f({ variables });
        this.props.form.resetFields();
        if (this.props.onCancel) {
          this.props.onCancel();
        }
      }
    });
  }

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  handleSwitchTranslate = (e) => {
    const appHtml = document.getElementsByTagName('html');

    if (e.target.checked) {
      localStorage.setItem('useTranslator', 'true');
      if (appHtml && appHtml[0]) appHtml[0].removeAttribute('translate');
    } else if (!e.target.checked) {
      localStorage.setItem('useTranslator', 'false');
      if (appHtml && appHtml[0]) appHtml[0].setAttribute('translate', 'no');
    }

    this.setState({ useTranslator: e.target.checked });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }] })(
              <TextField
                id="name"
                label="name"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder="name"
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('email', { initialValue: (this.props.email || ''), rules: [{ required: true }] })(
              <TextField
                id="email"
                label="email"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder="email"
                disabled
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('password', { initialValue: (this.props.password || ''), rules: [{ required: true }] })(
              <TextField
                id="password"
                label="password"
                type="password"
                color="primary"
                fullWidth
                style={{ marginTop: 13 }}
                InputLabelProps={{ shrink: true }}
                placeholder="password"
              />,
            )}
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={(
                <Switch
                  checked={this.state.useTranslator}
                  onChange={this.handleSwitchTranslate}
                  name="canUseTranslator"
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
              )}
              label="Use Translator"
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

const sitesForm = Form.create()(siteForm);
export default sitesForm;
